export const wissel = [
    "NORMAL_SWITCH", //0
    "SYMMETRIC_SWITCH", //1
    "ENGLISH_SWITCH", //2
    "HALF_ENGLISH_SWITCH", //3
    "INTERSECTION_SWITCH" //4
];
export const hoek = [
    "1_9", //0
    "1_15", //1
    "1_4,5_2x1_9", //2
    "1_12", //3
];
export const wisselLigger = [
    "CONCRETE", //0
    "WOOD" //1
];
export const profiel = [
    "54E1", //0
    "54E5", //1
    // "540"//2
];
export const richting = [
    "LEFT", //0
    "RIGHT", //1
    "SYMMETRIC" //2
];
export const boogstraal = [
    "195", //0
    "725", //1
    "390", //2
    "204", //3
    "260", //4
    "400", //5
    "465", //6
    "1200", //7
    "600", //8
];
export const been = [
    "L_LEG_LEFT", //0
    "L_LEG_RIGHT", //1
    "L_LEG_LEFT_OUTSIDE", //2
    "L_LEG_LEFT_INSIDE", //3
    "L_LEG_RIGHT_OUTSIDE", //4
    "L_LEG_RIGHT_INSIDE", //5
];
export const materiaal = [
    "R260MN", //0
    "R370LHT", //1
    "R350HT", //2
    "R260MN_WELDED" //3
];
export const berijdingsklasse = [
    "1TM4", //0
    "5TM6", //1
];
export const wisselVerwarmingVoorbereid = [
    "L_HEATING_CENTRAL", //0
    "L_HEATING_PREPARED" //1
];
export const tongenProfiel = [
    "L_LOW", //0
    "L_HIGH", //1
];
export const stoelenEnTapeind = [
    "L_CHAIRS_NONE", //0
    "L_CHAIRS_CONCRETE_SLEEPERS", //1
    "L_CHAIRS_CONCRETE_SLEEPERS_TAPE", //2
    "L_CHAIRS_SLIDING_EBI", //3
    "L_CHAIRS_SLIDING_EBI_TAPE", //4
    "L_CHAIRS_TAPE", //5
    "L_CHAIRS_WOOD_SLEEPERS_TAPE", //6
    "L_CHAIRS_TAPE_EBI", //7
    "L_CHAIRS_WOOD_SLEEPERS", //8
];
export const bediening = [
    "L_OPERATION_EBI", //0
    "L_OPERATION_OTHER", //1
];
export const smeerlozeConstructie = [
    "L_LUBRICANT_FREE_AUSTROROLL", //0
    "L_LUBRICANT_FREE_DELTA_SWITCH", //1
    "L_LUBRICANT_FREE_EKOS", //2
];
export const wisselstellerDescription = [
    "WISSELSTELLER_DESC_0",
    "WISSELSTELLER_DESC_1",
    "WISSELSTELLER_DESC_2",
    "WISSELSTELLER_DESC_3",
    "WISSELSTELLER_DESC_4",
    "WISSELSTELLER_DESC_5",
];
export const wisselstellerDirections = [
    "WISSELSTELLER_DIRECTION_0",
    "WISSELSTELLER_DIRECTION_1",
];
